/**
 * Telugu (తెలుగు) translations for the MyTownly Admin Panel.
 *
 * Keys are the exact English strings used in JSX.
 * If a key is missing, LangContext falls back to the English string — never undefined.
 */
const te = {
  // ── Sidebar nav labels ────────────────────────────────────────────────────
  'Dashboard':              'డాష్‌బోర్డ్',
  'AI Super Tool':          'AI సూపర్ టూల్',
  'Analytics':              'విశ్లేషణలు',
  'Demand Heatmap':         'డిమాండ్ హీట్‌మ్యాప్',
  'Live map':               'లైవ్ మ్యాప్',
  'Road Network':           'రోడ్ నెట్‌వర్క్',
  'Rides':                  'రైడ్లు',
  'Annas (Drivers)':        'అన్నలు (డ్రైవర్లు)',
  'Passengers':             'ప్రయాణికులు',
  'Anna Leaderboard':       'అన్న లీడర్‌బోర్డ్',
  'Flagged / Issues':       'ఫ్లాగ్ / సమస్యలు',
  'Phone Dispatch':         'ఫోన్ డిస్పాచ్',
  'Intertown':              'ఇంటర్‌టౌన్',
  'Broadcast FCM':          'FCM ప్రసారాలు',
  'Map Ads':                'మ్యాప్ ప్రకటనలు',
  'CAMPAIGN CONTROL':       'ప్రచార నియంత్రణ',
  'Manage the tappable top banner and the sponsored tag behind the auto.': 'టాప్ బ్యానర్ మరియు ఆటో వెనుక కనిపించే ప్రకటన ట్యాగ్‌ను నిర్వహించండి.',
  'Ads enabled':            'ప్రకటనలు ఆన్‌లో ఉన్నాయి',
  'All ads off':            'అన్ని ప్రకటనలు ఆఫ్‌లో ఉన్నాయి',
  'Eligible campaigns can appear in supported passenger builds': 'అర్హమైన ప్రచారాలు మద్దతు ఉన్న ప్రయాణికుల యాప్‌లో కనిపిస్తాయి',
  'Safe default · no campaign is shown': 'సురక్షిత డిఫాల్ట్ · ఏ ప్రచారం కనిపించదు',
  'Reviewer access is read only. A Super Admin with MFA is required to change campaigns.': 'రివ్యూయర్‌కు వీక్షణ అనుమతి మాత్రమే ఉంది. ప్రచారాలను మార్చడానికి MFA ఉన్న సూపర్ అడ్మిన్ అవసరం.',
  'Campaigns':              'ప్రచారాలు',
  'New':                    'కొత్తది',
  'Edit campaign':          'ప్రచారాన్ని సవరించండి',
  'New campaign':           'కొత్త ప్రచారం',
  'Save changes as a draft. Publish is a separate action.': 'మార్పులను డ్రాఫ్ట్‌గా సేవ్ చేయండి. ప్రచురణ వేరే చర్య.',
  'Saved draft changes are not live until you publish again.': 'మళ్లీ ప్రచురించే వరకు సేవ్ చేసిన డ్రాఫ్ట్ మార్పులు లైవ్ కావు.',
  'Internal campaign name': 'అంతర్గత ప్రచార పేరు',
  'Sponsor shown to riders': 'ప్రయాణికులకు కనిపించే స్పాన్సర్',
  'Top banner headline':   'టాప్ బ్యానర్ శీర్షిక',
  'Banner text (read aloud)': 'బ్యానర్ పాఠ్యం (చదివి వినిపించేది)',
  'Type the words that are in the banner image, for screen readers. Not drawn on the banner.': 'బ్యానర్ చిత్రంలో ఉన్న పదాలనే టైప్ చేయండి (స్క్రీన్ రీడర్ల కోసం). ఇవి బ్యానర్‌పై కనిపించవు.',
  'One full-width image with the text inside it, shown across the top of the map just below the phone’s clock bar. Use the whole image; fade the bottom edge so it blends into the map.': 'పాఠ్యం లోపలే ఉన్న ఒకే పూర్తి వెడల్పు చిత్రం, ఫోన్ గడియారం బార్ కిందే మ్యాప్ పైభాగంలో కనిపిస్తుంది. చిత్రం మొత్తాన్ని వాడండి; మ్యాప్‌లో కలిసిపోయేలా కింది అంచును మసకబార్చండి.',
  'Product destination · HTTPS': 'ఉత్పత్తి లింక్ · HTTPS',
  'Opens when a rider taps the top banner.': 'ప్రయాణికుడు టాప్ బ్యానర్‌ను నొక్కితే ఈ లింక్ తెరుచుకుంటుంది.',
  'Placements':             'ప్రకటన స్థానాలు',
  'Tappable top banner':    'నొక్కగల టాప్ బ్యానర్',
  'Auto-tail tag':          'ఆటో వెనుక ట్యాగ్',
  'Top banner image':       'టాప్ బ్యానర్ చిత్రం',
  'Auto tag image':         'ఆటో ట్యాగ్ చిత్రం',
  'Upload top banner':      'టాప్ బ్యానర్ అప్‌లోడ్ చేయండి',
  'Upload auto tag':        'ఆటో ట్యాగ్ అప్‌లోడ్ చేయండి',
  'Ride phase':             'ప్రయాణ దశ',
  'Where to show':          'ఎక్కడ చూపాలి',
  'Everywhere':             'అన్ని చోట్ల',
  'Book (home) screen':     'బుక్ (హోమ్) స్క్రీన్',
  'Searching for an Anna':  'అన్న కోసం వెతుకుతున్నప్పుడు',
  'Approaching pickup (banner + auto tag)': 'పికప్‌కి వస్తున్నప్పుడు (బ్యానర్ + ఆటో ట్యాగ్)',
  'During trip (banner + auto tag)': 'ప్రయాణంలో (బ్యానర్ + ఆటో ట్యాగ్)',
  'The auto tag shows only on Approaching pickup or During trip.': 'ఆటో ట్యాగ్ పికప్‌కి వస్తున్నప్పుడు లేదా ప్రయాణంలో మాత్రమే కనిపిస్తుంది.',
  'Show in towns':          'ఏ ఊర్లలో చూపాలి',
  'All towns':              'అన్ని ఊర్లు',
  'switched off':           'ఆఫ్‌లో ఉంది',
  'town removed from Settings': 'సెట్టింగ్స్ నుండి తీసేసిన ఊరు',
  'Tick at least one town.': 'కనీసం ఒక ఊరిని ఎంచుకోండి.',
  'Approaching pickup':    'పికప్‌కి వస్తున్నప్పుడు',
  'During trip':           'ప్రయాణంలో',
  'Starts · IST':          'ప్రారంభం · IST',
  'Ends · IST':            'ముగింపు · IST',
  'Save draft':            'డ్రాఫ్ట్ సేవ్ చేయండి',
  'Publish campaign':      'ప్రచారాన్ని ప్రచురించండి',
  'Publishing…':           'ప్రచురిస్తున్నారు…',
  'Pause':                 'నిలిపివేయండి',
  'Resume':                'మళ్లీ ప్రారంభించండి',
  'Archive':               'ఆర్కైవ్ చేయండి',
  draft:                   'డ్రాఫ్ట్',
  published:               'ప్రచురించబడింది',
  paused:                  'నిలిపివేయబడింది',
  archived:                'ఆర్కైవ్ చేయబడింది',
  'Live preview':          'లైవ్ ప్రివ్యూ',
  'Conceptual passenger placement': 'ప్రయాణికుల స్క్రీన్ నమూనా',
  'SOS inbox':              'SOS ఇన్‌బాక్స్',
  'Stuck rides':            'నిలిచిపోయిన రైడ్లు',
  'Deletions':              'తొలగింపులు',
  'Cash today':             'నేటి నగదు',
  'Settings':               'సెట్టింగ్లు',
  'Activity':               'యాక్టివిటీ',

  // ── Sidebar section headers ───────────────────────────────────────────────
  'OVERVIEW':               'అవలోకనం',
  'OPS':                    'ఆపరేషన్స్',
  'SYSTEM':                 'సిస్టమ్',

  // ── Sidebar footer ────────────────────────────────────────────────────────
  'COMMAND CENTER':            'కమాండ్ సెంటర్',
  'OPERATIONS COMMAND CENTER': 'ఆపరేషన్స్ కమాండ్ సెంటర్',
  'Sign out':                  'సైన్ అవుట్',

  // ── Page titles (topbar) ──────────────────────────────────────────────────
  'Admin AI Super Tool (Fleet Intelligence & Copilot)': 'అడ్మిన్ AI సూపర్ టూల్',
  'Passenger Demand & Missed Surge Heatmap':            'ప్రయాణికుల డిమాండ్ హీట్‌మ్యాప్',
  'Piler Road Network & Trace Explorer':                'పిలేరు రోడ్ నెట్‌వర్క్',
  'Anna Fleet Leaderboard & Weekly Champions':          'అన్న ఫ్లీట్ లీడర్‌బోర్డ్',
  'Flagged Rides & Safety Issues':                      'ఫ్లాగ్ రైడ్లు & భద్రతా సమస్యలు',
  'Manual Telephone Dispatcher':                        'మాన్యువల్ టెలిఫోన్ డిస్పాచ్',
  'Intertown control centre':                           'ఇంటర్‌టౌన్ కంట్రోల్ సెంటర్',
  'Broadcast FCM Announcements':                        'FCM ప్రసారాలు',
  'SOS / emergency inbox':                              'SOS / అత్యవసర ఇన్‌బాక్స్',
  'Stuck ride queue':                                   'నిలిచిపోయిన రైడ్ క్యూ',
  'Annas Fleet (Drivers)':                              'అన్నల ఫ్లీట్ (డ్రైవర్లు)',
  'Account deletion requests':                          'ఖాతా తొలగింపు అభ్యర్థనలు',
  'Activity log':                                       'యాక్టివిటీ లాగ్',

  // ── Topbar status pills ───────────────────────────────────────────────────
  'Annas Online':                  'అన్నలు ఆన్లైన్లో',
  'live':                          'లైవ్',
  'marked online':                 'ఆన్లైన్ అని మార్క్ చేసినవి',
  'Live = sending GPS in the last 3 minutes. Marked online = switched on in the app, including phones that have gone quiet.':
                                   'లైవ్ = గత 3 నిమిషాల్లో GPS పంపుతున్నవి. ఆన్లైన్ అని మార్క్ చేసినవి = యాప్‌లో ఆన్ చేసినవి, ఫోన్ ఆగిపోయినవి కూడా కలిపి.',
  'SOS ALARM':                     'SOS అలారం',

  // ── Dashboard: stat card labels ───────────────────────────────────────────
  "TODAY'S GMV (TOTAL FARES)":     'నేటి మొత్తం అద్దె సంపాదన',
  'COMPLETION RATE':               'పూర్తి రేటు',
  'LIVE ACTIVE TRIPS':             'లైవ్ యాక్టివ్ రైడ్లు',
  'ONLINE FLEET (PILER)':          'ఆన్లైన్ ఫ్లీట్ (పిలేరు)',
  'COMMISSION DUES OWED':          'పెండింగ్ కమిషన్',

  // ── Dashboard: stat card sub-text fragments ───────────────────────────────
  'trips completed':               'ట్రిప్పులు పూర్తయ్యాయి',
  'avg fare':                      'సగటు అద్దె',
  'cancelled':                     'రద్దు',
  'searching':                     'వెతుకుతున్నాయి',
  'matching':                      'మ్యాచింగ్',
  'stuck':                         'నిలిచిపోయినవి',
  'on active trips':               'యాక్టివ్ రైడ్లలో',
  'pending KYC':                   'KYC పెండింగ్',
  'All safety parameters clean':   'అన్ని భద్రతా పారామీటర్లు సురక్షితం',
  'prank flagged users':           'ప్రాంక్ ఫ్లాగ్ చేసిన యూజర్లు',

  // ── Dashboard: ops hub ───────────────────────────────────────────────────
  'Take manual passenger calls':   'మాన్యువల్ ప్రయాణికుల కాల్స్ తీసుకోండి',
  'Fleet Broadcast':               'ఫ్లీట్ ప్రసారం',
  '1-Click rain & rush alerts':    '1-క్లిక్ వర్షం & రష్ అలర్ట్లు',
  'SOS Alarm Desk':                'SOS అలారం డెస్క్',
  'Zero active distress':          'అత్యవసర పరిస్థితులు లేవు',
  'Live Fleet Radar':              'లైవ్ ఫ్లీట్ రాడార్',
  'Real-time GPS tracking in Piler': 'పిలేరులో రియల్-టైమ్ GPS ట్రాకింగ్',

  // ── Dashboard: ops alert banner ───────────────────────────────────────────
  'Operations Attention Required': 'ఆపరేషన్స్ శ్రద్ధ అవసరం',
  'Open SOS Desk Now →':           'SOS డెస్క్ ఇప్పుడు తెరవండి →',
  'Open Stuck Queue →':            'నిలిచిపోయిన క్యూ తెరవండి →',
  'Open review queue →':           'రివ్యూ క్యూ తెరవండి →',
  'See applicants →':              'దరఖాస్తుదారులను చూడండి →',

  // ── Dashboard: live rides table ───────────────────────────────────────────
  '🛺 Live Ride Operations Stream': '🛺 లైవ్ రైడ్ ఆపరేషన్స్ స్ట్రీమ్',
  'View All':                      'అన్నీ చూడండి',
  'No active rides in Piler right now': 'పిలేరులో ప్రస్తుతం యాక్టివ్ రైడ్లు లేవు',
  'STATUS':                        'స్థితి',
  'ROUTE (PICKUP → DROP)':         'మార్గం (పికప్ → డ్రాప్)',
  'FARE':                          'అద్దె',
  'PASSENGER':                     'ప్రయాణికుడు',
  'CAPTAIN':                       'కెప్టెన్',
  'ACTIONS':                       'చర్యలు',
  'Finding…':                      'వెతుకుతున్నారు…',

  // ── Dashboard: online captains card ──────────────────────────────────────
  'Active Captains':               'యాక్టివ్ కెప్టెన్లు',
  'Fleet List →':                  'ఫ్లీట్ జాబితా →',
  'No captains currently online':  'ప్రస్తుతం కెప్టెన్లు ఆన్లైన్లో లేరు',

  // ── Drivers: filter dropdown options ─────────────────────────────────────
  'All Annas':                     'అన్ని అన్నలు',
  'High Risk':                     'అధిక రిస్క్',
  'Has Complaints':                'ఫిర్యాదులు ఉన్నాయి',
  'Online now':                    'ఇప్పుడు ఆన్లైన్',
  'Offline':                       'ఆఫ్లైన్',
  'Top Rated':                     'టాప్ రేటెడ్',
  'Pending approval':              'ఆమోదం పెండింగ్',
  'Docs waiting review':           'డాక్లు రివ్యూ కోసం వేచి',
  'Docs Verified (3+)':            'డాక్లు వెరిఫై (3+)',
  'Vehicle Safety Ready':          'వాహన భద్రత సిద్ధం',
  'Photo waiting review':          'ఫోటో రివ్యూ కోసం వేచి',
  'Approved':                      'ఆమోదించబడింది',
  'Blocked / Suspended':           'బ్లాక్ / సస్పెండ్',
  'Export CSV':                    'CSV ఎగుమతి',

  // ── Drivers: table headers ────────────────────────────────────────────────
  'ANNA / DRIVER':                 'అన్న / డ్రైవర్',
  'VEHICLE':                       'వాహనం',
  'PERFORMANCE':                   'పనితీరు',
  'STATUS & FLAGS':                'స్థితి & ఫ్లాగ్లు',
  'CHECKLIST':                     'చెక్‌లిస్ట్',

  // ── Drivers: status badges ────────────────────────────────────────────────
  'Blocked':                       'బ్లాక్',
  'Pending':                       'పెండింగ్',
  'Online':                        'ఆన్లైన్',
  'After trip hold':               'ట్రిప్ తర్వాత హోల్డ్',

  // ── Drivers: action buttons (table rows) ─────────────────────────────────
  '✓ Approve':                     '✓ ఆమోదించు',
  'Approving…':                    'ఆమోదిస్తున్నారు…',
  'Unapprove':                     'ఆమోదం రద్దు',
  'Cancel scheduled offline':      'షెడ్యూల్ ఆఫ్లైన్ రద్దు',
  'Updating…':                     'అప్‌డేట్ చేస్తున్నారు…',
  '📋 360 Dossier':                '📋 360 డొజియర్',
  '✏️ Edit':                       '✏️ సవరించు',
  '📄 Docs':                       '📄 డాక్లు',
  '🗑️ Delete':                     '🗑️ తొలగించు',

  // ── Drivers: empty state ──────────────────────────────────────────────────
  'No Annas match this filter':    'ఈ ఫిల్టర్‌కు అన్నలు లేరు',

  // ── Login screen ──────────────────────────────────────────────────────────
  'Admin Sign In':                 'అడ్మిన్ సైన్ ఇన్',
  'Enter credentials to access the fleet control desk.': 'ఫ్లీట్ కంట్రోల్ డెస్క్‌ని యాక్సెస్ చేయడానికి వివరాలను నమోదు చేయండి.',
  'ADMIN EMAIL':                   'అడ్మిన్ ఈమెయిల్',
  'PASSWORD':                      'పాస్‌వర్డ్',
  'Sign In to Portal →':           'పోర్టల్‌కి సైన్ ఇన్ చేయండి →',
  'Authenticating…':               'ధృవీకరిస్తున్నారు…',
  'Two-Factor Authentication':     'రెండు-దశల ప్రామాణీకరణ (2FA)',
  'Enter the current 6-digit code from your authenticator app (Google Authenticator, Microsoft Authenticator, Authy, 1Password).': 'మీ అథెంటికేటర్ యాప్ నుండి 6-అంకెల కోడ్‌ను నమోదు చేయండి.',
  '6-DIGIT VERIFICATION CODE':     '6-అంకెల ధృవీకరణ కోడ్',
  'Verify & Continue →':           'ధృవీకరించి కొనసాగండి →',
  'Verifying 2FA…':                '2FA ధృవీకరిస్తున్నారు…',
  '← Back to login':               '← లాగిన్‌కి తిరిగి వెళ్లండి',
  'Secured with Firebase Multi-Factor Authentication (MFA).': 'Firebase మల్టీ-ఫాక్టర్ అథెంటికేషన్ (MFA) తో భద్రపరచబడింది.',

  // ── Dispatch: Phone Booking ───────────────────────────────────────────────
  'AVAILABLE CAPTAINS':            'అందుబాటులో ఉన్న కెప్టెన్లు',
  'Ready to receive phone dispatch in Piler': 'పిలేరులో ఫోన్ డిస్పాచ్ స్వీకరించడానికి సిద్ధంగా ఉన్నారు',
  'DISPATCH MODE':                 'డిస్పాచ్ మోడ్',
  'Manual Phone Call':             'మాన్యువల్ ఫోన్ కాల్',
  'Local Piler telephone dispatch desk': 'స్థానిక పిలేరు టెలిఫోన్ డిస్పాచ్ డెస్క్',
  '🛺 Manual Telephone Booking & Dispatcher': '🛺 మాన్యువల్ టెలిఫోన్ బుకింగ్ & డిస్పాచర్',
  '👤 PASSENGER NAME (OPTIONAL)':   '👤 ప్రయాణికుడి పేరు (ఐచ్ఛికం)',
  '📱 PASSENGER PHONE NUMBER *':   '📱 ప్రయాణికుడి ఫోన్ నంబర్ *',
  '📍 PICKUP LOCATION (PILER PRESETS)': '📍 పికప్ ప్రాంతం (పిలేరు స్థలాలు)',
  '🏁 DROP DESTINATION (PILER PRESETS)': '🏁 డ్రాప్ ప్రాంతం (పిలేరు స్థలాలు)',
  '💵 FARE CALCULATION (₹)':       '💵 అంచనా అద్దె (₹)',
  '₹30 Min':                       '₹30 కనీసం',
  '₹40 Local':                     '₹40 లోకల్',
  '₹60 Outstation':                '₹60 అవుట్‌స్టేషన్',
  '🛺 Dispatch Ride Now':           '🛺 ఇప్పుడే రైడ్ డిస్పాచ్ చేయండి',
  'Dispatching...':                'డిస్పాచ్ చేస్తున్నారు…',
  '🚫 No Captains Online':         '🚫 కెప్టెన్లు ఆన్లైన్లో లేరు',
  'APSRTC Bus Stand 🚌':           'APSRTC బస్ స్టాండ్ 🚌',
  'Pileru Railway Station 🚆':      'పిలేరు రైల్వే స్టేషన్ 🚆',
  'Govt. Hospital Pileru 🏥':      'ప్రభుత్వ ఆసుపత్రి పిలేరు 🏥',
  'Main Market 🛍️':                'మెయిన్ మార్కెట్ 🛍️',

  // ── Driver Docs Modal ─────────────────────────────────────────────────────
  '📄 Anna Verification & Compliance Dossier': '📄 అన్న ధృవీకరణ & పత్రాల డొజియర్',
  'Close':                         'మూసివేయి',
  'Driving Licence (DL)':          'డ్రైవింగ్ లైసెన్స్ (DL)',
  'Vehicle Registration (RC)':     'వాహన రిజిస్ట్రేషన్ (RC)',
  'Commercial Auto Insurance':     'కమర్షియల్ ఆటో ఇన్సూరెన్స్',
  'Auto Insurance Policy':         'ఆటో ఇన్సూరెన్స్ పాలసీ',
  'Government Aadhaar Card':       'ప్రభుత్వ ఆధార్ కార్డు',
  'Aadhaar Card':                  'ఆధార్ కార్డు',
  'Passenger Vehicle Safety':      'ప్రయాణికుల వాహన భద్రత',
  '✓ Verified':                    '✓ ఆమోదించబడింది',
  '⏳ In Review':                   '⏳ పరిశీలనలో ఉంది',
  '✕ Rejected':                    '✕ తిరస్కరించబడింది',
  'Not Uploaded':                  'అప్‌లోడ్ చేయలేదు',
  '✓ Approve DL':                  '✓ DL ఆమోదించు',
  '✓ DL Verified':                 '✓ DL ఆమోదించబడింది',
  '✕ Reject DL':                   '✕ DL తిరస్కరించు',
  '✓ Approve RC':                  '✓ RC ఆమోదించు',
  '✓ RC Verified':                 '✓ RC ఆమోదించబడింది',
  '✕ Reject RC':                   '✕ RC తిరస్కరించు',
  '✓ Approve Insurance':           '✓ ఇన్సూరెన్స్ ఆమోదించు',
  '✓ Insurance Verified':          '✓ ఇన్సూరెన్స్ ఆమోదించబడింది',
  '✕ Reject Insurance':            '✕ ఇన్సూరెన్స్ తిరస్కరించు',
  '✓ Approve Aadhaar':             '✓ ఆధార్ ఆమోదించు',
  '✓ Aadhaar Verified':            '✓ ఆధార్ ఆమోదించబడింది',
  '✕ Reject Aadhaar':              '✕ ఆధార్ తిరస్కరించు',
  'Confirm Reject':                'తిరస్కరణ నిర్ధారించు',
  'Cancel':                        'రద్దు',
  'Save Safety Details':           'భద్రతా వివరాలు భద్రపరుచు',
  'Search name or phone…':         'పేరు లేదా ఫోన్ వెతకండి…',
  'Search name, phone, vehicle, place…': 'పేరు, ఫోన్, వాహనం, స్థలం వెతకండి…',
  'Search receipt, captain, vehicle, admin…': 'రసీదు, కెప్టెన్, వాహనం, అడ్మిన్ వెతకండి…',
  'Search issue, passenger, captain, phone…': 'సమస్య, ప్రయాణికుడు, కెప్టెన్, ఫోన్ వెతకండి…',
  'Search name, phone, vehicle, ID…': 'పేరు, ఫోన్, వాహనం, ID వెతకండి…',
  'Pickup address':                'పికప్ చిరునామా',
  'Drop address':                  'డ్రాప్ చిరునామా',
  'Call':                          'కాల్ చేయండి',
  'Call pax':                      'ప్రయాణికుడికి కాల్',
  'No records matching filter':    'ఈ ఫిల్టర్‌కు రికార్డులు లేవు',
  'Zero Pending Deletion Requests': 'తొలగింపు అభ్యర్థనలు పెండింగ్‌లో లేవు',
  'No passengers match filter':    'ఈ ఫిల్టర్‌కు ప్రయాణికులు లేరు',
  'No rides match filter':         'ఈ ఫిల్టర్‌కు రైడ్లు లేవు',
  'No completed rides yet':        'ఇంకా పూర్తయిన రైడ్లు లేవు',
  'No completed rides yet.':       'ఇంకా పూర్తయిన రైడ్లు లేవు.',
  'No corridor data yet':           'ఇంకా మార్గ డేటా లేదు',
  'Active':                        'యాక్టివ్',
  'Searching':                    'వెతుకుతున్నారు',
  'Completed':                    'పూర్తయింది',
  'Cancelled':                    'రద్దయింది',
  'Good Standing':                'మంచి స్థితి',
  'Pending Review':               'పరిశీలన పెండింగ్',
  'Fulfilled':                    'పూర్తి చేయబడింది',
  'Rejected':                     'తిరస్కరించబడింది',
  'No flagged incidents':          'ఫ్లాగ్ చేసిన సంఘటనలు లేవు',
  'All rides operating smoothly with zero reported complaints.': 'ఫిర్యాదులు లేకుండా అన్ని రైడ్లు సజావుగా నడుస్తున్నాయి.',
  'No stuck rides — looking good': 'నిలిచిపోయిన రైడ్లు లేవు — పరిస్థితి బాగుంది',
  'Refresh':                      'రిఫ్రెష్',
  'Action failed':                'చర్య విఫలమైంది',
  'Welcome back':                 'తిరిగి స్వాగతం',
  'Failed to verify document':    'పత్రాన్ని ధృవీకరించడం విఫలమైంది',
  'Failed to reject document':    'పత్రాన్ని తిరస్కరించడం విఫలమైంది',
  'Vehicle safety details saved': 'వాహన భద్రత వివరాలు సేవ్ అయ్యాయి',
  'Failed to save vehicle safety details': 'వాహన భద్రత వివరాలను సేవ్ చేయడం విఫలమైంది',
  'Annas':                          'అన్నలు',
  'Photo':                          'ఫోటో',
  'New profile / auto photo waiting for review': 'కొత్త ప్రొఫైల్ / ఆటో ఫోటో పరిశీలన కోసం వేచి ఉంది',
  'Risk':                           'రిస్క్',
  'Stop after trip':                'ట్రిప్ తర్వాత ఆపండి',
  'Take offline':                   'ఆఫ్లైన్ చేయండి',
  'Night: ON':                      'రాత్రి: ఆన్',
  'Night: OFF':                     'రాత్రి: ఆఫ్',
  '2FA verified — welcome to Command Center': '2FA ధృవీకరించబడింది — కమాండ్ సెంటర్‌కు స్వాగతం',
  'All Rides':                      'అన్ని రైడ్లు',
  'All Passengers':                 'అన్ని ప్రయాణికులు',
  'STATUS':                         'స్థితి',
  'ROUTE':                          'మార్గం',
  'TIME':                           'సమయం',
  'CAPTAIN':                        'కెప్టెన్',
  'PHONE':                          'ఫోన్',
  'RIDES & SPEND':                  'రైడ్లు & ఖర్చు',
  'HOME / WORK':                    'ఇల్లు / పని',
  'SAFETY STATUS':                  'భద్రత స్థితి',
  'JOINED':                         'చేరిన తేదీ',
  'Admin activity':                 'అడ్మిన్ యాక్టివిటీ',
  'No admin actions logged yet':     'ఇంకా అడ్మిన్ చర్యలు నమోదు కాలేదు',
  'WHEN':                           'ఎప్పుడు',
  'ACTION':                         'చర్య',
  'ADMIN':                          'అడ్మిన్',
  'DETAILS':                        'వివరాలు',
  'TODAY COMPLETED':                'ఈ రోజు పూర్తయినవి',
  'AVG FARE':                       'సగటు అద్దె',
  'AVG RATING':                     'సగటు రేటింగ్',
  'ACTIVE ANNAS':                   'యాక్టివ్ అన్నలు',
  '🧪 Dispatch & Acceptance Performance': '🧪 డిస్పాచ్ & స్వీకరణ పనితీరు',
  'MEDIAN TIME TO ACCEPT':          'స్వీకరించడానికి మధ్యస్థ సమయం',
  'FLEET ACCEPTANCE RATE':          'ఫ్లీట్ స్వీకరణ రేటు',
  'Successful matches':             'విజయవంతమైన మ్యాచింగ్‌లు',
  'TRIP COMPLETION RATE':           'ట్రిప్ పూర్తి రేటు',
  'Fulfilled passenger rides':      'పూర్తయిన ప్రయాణికుల రైడ్లు',
  'CANCELLATION RATE':              'రద్దు రేటు',
  'Cancelled bookings':             'రద్దైన బుకింగ్‌లు',
  '📍 Top Piler Corridors (High Demand Routes)': '📍 టాప్ పిలేరు మార్గాలు (అధిక డిమాండ్)',
  '🏆 Top Annas (Completed Rides)': '🏆 టాప్ అన్నలు (పూర్తయిన రైడ్లు)',
  'Title and message body are required.': 'శీర్షిక మరియు సందేశం అవసరం.',
  '📢 1-Click Broadcast dispatched to devices!': '📢 ఒక క్లిక్ ప్రసారం పరికరాలకు పంపబడింది!',
  'Failed to send broadcast.':         'ప్రసారం పంపడం విఫలమైంది.',
  'REGISTERED PASSENGERS':             'నమోదైన ప్రయాణికులు',
  'ONLINE CAPTAINS':                   'ఆన్లైన్ కెప్టెన్లు',
  'TOTAL CAPTAINS':                    'మొత్తం కెప్టెన్లు',
  '📢 1-Click Broadcast Push Notification Tool': '📢 ఒక క్లిక్ ప్రసార పుష్ నోటిఫికేషన్ టూల్',
  '⚡ 1-CLICK PRESETS FOR PASSENGERS': '⚡ ప్రయాణికుల కోసం ఒక క్లిక్ ప్రీసెట్లు',
  '🛺 1-CLICK PRESETS FOR CAPTAINS':   '🛺 కెప్టెన్ల కోసం ఒక క్లిక్ ప్రీసెట్లు',
  '👥 TARGET AUDIENCE':                '👥 లక్ష్య ప్రేక్షకులు',
  '🌐 NOTIFICATION LANGUAGE':          '🌐 నోటిఫికేషన్ భాష',
  '🔔 NOTIFICATION TITLE':             '🔔 నోటిఫికేషన్ శీర్షిక',
  '📝 MESSAGE BODY':                   '📝 సందేశం',
  'Platform settings':                'ప్లాట్‌ఫారమ్ సెట్టింగ్లు',
  'Changes apply to passenger & driver apps without redeploy (when signed in).': 'సైన్ ఇన్ చేసినప్పుడు మార్పులు ప్యాసింజర్ మరియు డ్రైవర్ యాప్‌లకు రీడిప్లాయ్ లేకుండా వర్తిస్తాయి.',
  'Support phone required':            'సపోర్ట్ ఫోన్ అవసరం',
  'Passenger SOS → “Call MyTownly support” uses this number. Enter a 10-digit mobile below and save.': 'ప్రయాణికుల SOS కోసం ఈ నంబర్ ఉపయోగించబడుతుంది. క్రింద 10-అంకెల మొబైల్ నంబర్ నమోదు చేసి సేవ్ చేయండి.',
  '10-digit mobile':                  '10-అంకెల మొబైల్',
  '91XXXXXXXXXX or 10 digits':        '91XXXXXXXXXX లేదా 10 అంకెలు',
  'Saving…':                          'సేవ్ చేస్తున్నారు…',
  'Save settings':                    'సెట్టింగ్లను సేవ్ చేయండి',
  'Authoritative Lifetime Accounting': 'అధికారిక జీవితకాల లెక్కలు',
  'Lifetime rides and fare totals strictly reflect true database history. Dues are collected at ₹5/completed trip (₹10 for trips booked after 10pm).': 'జీవితకాల రైడ్లు మరియు అద్దె మొత్తాలు నిజమైన డేటాబేస్ చరిత్రను ప్రతిబింబిస్తాయి. పూర్తయిన ప్రతి ట్రిప్‌కు ₹5 బకాయి వసూలు చేయబడుతుంది (రాత్రి 10 తర్వాత బుక్ చేసిన ట్రిప్‌లకు ₹10).',
  'Verifying All Drivers…':           'అన్ని డ్రైవర్లను ధృవీకరిస్తున్నారు…',
  '⚡ Reconcile All Drivers':          '⚡ అన్ని డ్రైవర్ల లెక్కలు సరిపోల్చండి',
  'PERIOD FILTER:':                   'కాల వ్యవధి ఫిల్టర్:',
  'This Week (7 days)':               'ఈ వారం (7 రోజులు)',
  'This Month (30 days)':             'ఈ నెల (30 రోజులు)',
  'All Time (Historic)':              'మొత్తం కాలం (చారిత్రక)',
  'Captain Dues Ledger':              'కెప్టెన్ బకాయిల లెడ్జర్',
  'Today':                           'ఈ రోజు',
  'Yesterday':                       'నిన్న',
  'Enter the 6-digit code from your authenticator app': 'మీ అథెంటికేటర్ యాప్‌లోని 6-అంకెల కోడ్‌ను నమోదు చేయండి',
  'verified successfully!':         'విజయవంతంగా ధృవీకరించబడింది!',
  'Please enter a rejection reason for the driver': 'డ్రైవర్ కోసం తిరస్కరణ కారణాన్ని నమోదు చేయండి',
  'rejected. Driver notified.':      'తిరస్కరించబడింది. డ్రైవర్‌కు తెలియజేయబడింది.',
  'KYC & Transport Documents':       'KYC & రవాణా పత్రాలు',
  'Fuel':                            'ఇంధనం',
  'Blood Group':                     'రక్త వర్గం',
  'Emergency Nominee':               'అత్యవసర నామినీ',
  'Publish only after checking the original records. At least 3 of 4 safety records are required.': 'అసలు రికార్డులను తనిఖీ చేసిన తర్వాత మాత్రమే ప్రచురించండి. 4 భద్రతా రికార్డుల్లో కనీసం 3 అవసరం.',
  'Show to passengers':              'ప్రయాణికులకు చూపించండి',
  'Valid':                          'చెల్లుబాటు',
  'Expired':                        'గడువు ముగిసింది',
  'Unavailable':                    'అందుబాటులో లేదు',
  'Dues hold':                      'బకాయి హోల్డ్',
  'Hold for dues':                  'బకాయి కోసం హోల్డ్',
  'Release hold':                   'హోల్డ్ తొలగించండి',
};

export default te;
